<template>
    <div id="storefront" class="content">
        <div class="container">
            <h1 class="mb-5">
                Storefront Setting
            </h1>
            <nav-storefront tab="store"></nav-storefront>
            <collection/>
        </div>
    </div>
</template>

<script>
    import CardTitle from "@/components/CardTitle";
    import CardBox from "@/components/CardBox";
    import Collection from "@/components/Collection";
    import MenuStore from "@/components/MenuStore";
    import NavStorefront from "../components/NavStorefront";

    export default {
        name: "Store",
        components: {NavStorefront, MenuStore, Collection, CardBox, CardTitle},
        data: function () {
            return {
                collections: [],

            }
        },
        mounted: function () {
            this.$store.commit('ACTIVE_SIDEBAR', 'store')


        },

    }
</script>

<style scoped lang="scss">

</style>
